export default "__VITE_ASSET__DYua79Wo__"